import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { UserContext } from "../../UserContext";
import '../topics.css';

const HabitBasics = () => {
  const { user } = useContext(UserContext);
  const category = "habits"; // Set category for habit-related videos
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch videos when the component mounts
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(`https://wholeness-forward.onrender.com/api/video/videos/${category}`);
        if (Array.isArray(response.data)) {
          setVideos(response.data);
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  // ✅ Handle Mark as Helpful
  const handleHelpfulClick = async (videoId) => {
    if (!user || !user.id) {
      alert("You must be logged in to mark as helpful.");
      return;
    }

    try {
      const response = await axios.post(`https://wholeness-forward.onrender.com/api/video/videos/toggleHelpful`, {
        videoId,
        userId: user.id,
      });

      // ✅ Update UI with new helpful count
      setVideos((prevVideos) =>
        prevVideos.map((video) =>
          video._id === videoId
            ? { ...video, helpfulCount: response.data.helpfulCount }
            : video
        )
      );
    } catch (error) {
      console.error("Error marking video as helpful:", error);
    }
  };

  return (
   


    
    <div className="page-container habit-page">
<p class="disclaimer">
Disclaimer: As an Amazon Associate, I earn from qualifying purchases. If you make a purchase through the links here, 
I may earn a small commission at no extra cost to you. Thank you for your support.
</p>
<div className="micro-void"></div>
      <h1 className="page-title">Habits: The Basics</h1>

      {/* Habit Image */}
      <img
        src="/images/habitbasics.png" 
        alt="Habit Formation"
        className="page-image"
        width="330"
      />
      <p className="page-description">
        Habits shape our lives—what we do daily determines our long-term well-being, productivity, and success. 
        Understanding how habits are formed can help you build positive routines and break free from negative patterns.
      </p>

      {/* How Habits Work */}
      <h2 className="section-title">How Habits Work</h2>
      <p className="section-description">
        Every habit follows a basic pattern known as the **Habit Loop**, consisting of three key stages:
      </p>
      <ul className="content-list">
        <li><strong>Cue (Trigger):</strong> A signal that prompts your brain to start the habit.</li>
        <li><strong>Routine (Action):</strong> The behavior itself.</li>
        <li><strong>Reward (Benefit):</strong> The positive feeling or result that reinforces the habit.</li>
      </ul>

      <hr className="section-divider" />

      {/* Health Benefits */}
      <h2 className="section-title">Why Building Good Habits Matters</h2>
      <ul className="content-list">
        <li>Reduces mental effort by automating positive behaviors.</li>
        <li>Boosts physical and mental well-being over time.</li>
        <li>Helps build consistency for long-term success.</li>
      </ul>

      <hr className="section-divider" />

      {/* Curated Video Collection */}
      <h2 className="section-title">Curated Video Collection</h2>

      {loading ? (
        <p className="loading-message">Loading videos...</p>
      ) : (
        <div className="video-container">
          {videos.length > 0 ? (
            videos.map((video) => (
              <div key={video._id} className="video-card">
                <h3 className="video-title">{video.title}</h3>
                <p className="video-details">
                  <strong>Source:</strong> {video.source} <br />
                  <strong>Length:</strong> {video.length} <br />
                  {video.description}
                </p>
                <iframe
                  className="video-frame"
                  src={video.url}
                  title={video.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>

                {/* ✅ Helpful Button */}
                <button
                  className="button"
                  onClick={() => handleHelpfulClick(video._id)}
                >
                  Mark as Helpful ({video.helpfulCount || 0})
                </button>
              </div>
            ))
          ) : (
            <p className="no-videos-message">No videos found for this category.</p>
          )}
        </div>
      )}

<hr className="section-divider" />
<h2 className="section-title">Curated Book Collection</h2>
<div className="book-card">
  <h3 className="book-title">Atomic Habits</h3>
  
   {/* Book Cover Image from Open Library */}
   <img 
    src="https://covers.openlibrary.org/b/id/10538014-M.jpg" // Open Library cover image URL
    alt="Atomic Habits by James Clear" 
    className="book-cover" 
  />
   {/* Attribution for Image Source */}
   <p className="image-source">Image Source: Open Library API</p>
   <div className="micro-void"></div>
   <p className="book-details">
  <strong>Author:</strong> James Clear <br />
  <div className="micro-void"></div>
  <strong>Description:</strong> In Atomic Habits, James Clear offers a proven system for building good habits 
  and breaking bad ones. He reveals practical strategies for making small, consistent changes that lead to remarkable 
  results. Clear explains that success isn’t about setting big goals, but about creating the right systems. 
  Drawing on insights from biology, psychology, and neuroscience, he provides an easy-to-follow guide to habit 
  formation, including tips on overcoming obstacles like lack of motivation, designing your environment for 
  success, and staying on track. Whether you're aiming to improve personally or professionally, Atomic Habits 
  gives you the tools to transform your habits and achieve lasting success. 
  This is the book that defines our current understanding of habits. It is full of enlightening anecdotes 
  and actionable advice.<br />
</p>
  
<div className="micro-void"></div>
<a
  href="https://amzn.to/4c6sS3d" // Your actual Amazon affiliate link
  className="amazon-link"
  target="_blank"
  rel="noopener noreferrer"
>
Buy on Amazon-https://amzn.to/4c6sS3d
</a>
{/* Affiliate Link Disclosure */}
<p className="affiliate-link-disclaimer">As an Amazon Associate, I earn from qualifying purchases.</p>
<div class="short-line"></div>

</div>
<div className="book-card">
  <h3 className="book-title">The Power of Habits</h3>
  
   {/* Book Cover Image from Open Library */}
   <img 
    src="https://covers.openlibrary.org/b/id/8753107-M.jpg" // Open Library cover image URL
    alt="Atomic Habits by James Clear" 
    className="book-cover" 
  />
   {/* Attribution for Image Source */}
   <p className="image-source">Image Source: Open Library API</p>
   <div className="micro-void"></div>
   <p className="book-details">
  <strong>Author:</strong> Charles Duhigg <br />
  <div className="micro-void"></div>
  <strong>Description:</strong> In The Power of Habit, Charles Duhigg explores the science of habits and 
  how they shape our lives, careers, and societies. Through engaging stories and scientific insights, 
  Duhigg shows how changing habits can lead to personal and professional transformation. From an individual’s 
  brain patterns to corporate success stories like Procter & Gamble’s Febreze, the book reveals how identifying 
  and changing key habits can drive remarkable results. With examples from Olympic athletes, CEOs, and social movements, 
  Duhigg argues that understanding habits is crucial to achieving success, improving productivity, and fostering 
  meaningful change. Habits aren’t fixed—they can be reshaped to unlock potential and create lasting transformation.<br />
</p>
  
<div className="micro-void"></div>
<a
  href="https://amzn.to/41FmAmp" // Your actual Amazon affiliate link
  className="amazon-link"
  target="_blank"
  rel="noopener noreferrer"
>
Buy on Amazon-https://amzn.to/41FmAmp
</a>
{/* Affiliate Link Disclosure */}
<p className="affiliate-link-disclaimer">As an Amazon Associate, I earn from qualifying purchases.</p>

</div>



<hr className="section-divider" />

      {/* Forum Section */}
      <div className="forum-section">
        <h2 className="section-title">Join the Habit Discussion</h2>
        <p className="section-description">
          Building habits is easier with support! Join our forum to share progress, challenges, and tips with others.
        </p>
        <a href="/forum/Habits" className="forum-link">
          Go to Habits Forum
        </a>
      </div>
    
    </div>
  );
};

export default HabitBasics;
